import "./js/main";
import "./scss/main.scss";
